module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wap"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "src": require("../assets/img/logo_header.svg")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        _vm.toggleFeature()
      }
    }
  }, [_c('div', {
    staticClass: "expand"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(this.$store.state.email.split('@')[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "feature",
    class: {
      hidden: this.IsShowFeature === false
    }
  }, [_c('div', {
    staticClass: "item last"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Log Out")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "bottomBar",
    class: {
      hidden: this.IsShowBottomBar === false
    },
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    class: {
      hidden: this.IsShowGotoTop === false
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "0px",
      "background-color": "#00aff0 !important"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-top"
  })])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "logoLast"
  }, [_c('img', {
    staticStyle: {
      "margin": "22px 40px 0px 20px"
    },
    attrs: {
      "src": require("../assets/img/logo_footer.svg")
    }
  })]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "color": "#dedede",
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://helpcenter.ef.com/",
      "target": "_blank"
    }
  }, [_vm._v("Help Center")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" © Ying Fu Jiao Yu 2025. All rights reserved.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2be4a67f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLayout.vue
// module id = 475
// module chunks = 2